

import React from "react";
import { Box } from "@mui/material";
import HeroSection from "./HeroSection";
import TrustedSection from "./TrustedSection";
import EstimateSection from "./EstimateSection";
import HowItWorksSection from "./HowItWorksSection";
import StatsSection from "./StatsSection";
import TeamSection from "./TeamSection";
import ServicesSection from "./ServicesSection";
import OfferBannerSection from "./OfferBannerSection";
import MarqueeStrip from "./MarqueeStrip";
import TestimonialsSection from "./TestimonialsSection";
import GallerySection from "./GallerySection";
import ContactSection from "./ContactSection";
import BlogSection from "./BlogSection";
import HeroCarousel from "./HeroCarousel";

const HomePage = () => {
  return (
    <>
      {/* Global extra styles used by a few sections */}
      <style>{`
        .bubble-bg {
          background-image: url("https://html.themehour.net/kleanix/demo/assets/img/shape/bubble_4.png");
          background-repeat: no-repeat;
          background-position: top left;
          background-size: contain;
        }

        .marquee {
          white-space: nowrap;
          overflow: hidden;
          position: relative;
        }

        .marquee-inner {
          display: inline-block;
          padding-left: 100%;
          animation: marqueeScroll 15s linear infinite;
          font-weight: 700;
          letter-spacing: 0.25em;
          text-transform: uppercase;
        }

        @keyframes marqueeScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `}</style>

      {/* <HeroSection /> */}
      <HeroCarousel/>

      <Box>
        <TrustedSection />
        <EstimateSection />
        <HowItWorksSection />
        <StatsSection />
        <TeamSection />
        <ServicesSection />
        <OfferBannerSection />
        <MarqueeStrip />
        <TestimonialsSection />
        <GallerySection />
        <ContactSection />
        <BlogSection />
      </Box>

    </>
  );
};

export default HomePage;
